var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_redefine-all.js
// module id = 42
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11